import BaseService from '../../BaseService.js';

export default class EvaluationService extends BaseService {
  constructor() {
    super('evaluations')
  }
}
